import React from 'react'

export default function ImagePopup() {
  return (
    <div>
      <img src=""/>
    </div>
  )
}
